export default class Structor {
  constructor(map) {
    const attributes = this.defineStruct()
    map = map || {}
    for (const key of Object.keys(attributes)) {
      const val = attributes[key]
      if (typeof val === "function") {
        attributes[key] = val(map)
      } else {
        attributes[key] = map[key] === undefined ? val : map[key]
      }
    }
    return attributes
  }
}
